import { Contest } from "interfaces/leaderboard/contest.ts";
import ContestItem from "./contest-item.tsx";
import { useNavigate } from "react-router-dom";
import styles from "./contest-item-home.module.scss";
import { useAppSelector } from "state/hooks.ts";
import { getEntriesByContestId } from "state/slices/contests-slice.ts";

interface ContestItemProps {
  contest: Contest;
}

const ContestItemHome = ({ contest }: ContestItemProps) => {

  const navigate = useNavigate();

  const userContestEntries = useAppSelector((state) => getEntriesByContestId(state, contest.id)) || [];

  const handleClick = () => {
    navigate(`/contest/${contest.id}`, { state: { contest: contest } });
  };

  return (
    <>
      <div
        className={styles.wrapper}
        onClick={handleClick}
      >
        <ContestItem contest={contest} userContestEntries={userContestEntries} />
      </div>
    </>
  );
};

export default ContestItemHome;
